import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { AiOutlineFileProtect } from "react-icons/ai";
import Page from 'src/components/Page';
import agm from '../../services/agm'

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';
import Results from './Results';
import Toolbar from './Toolbar';
import Contract from './Contract';
import Create from './Create';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  id: null,
  numero: null,
  nome: null,
  descricao: null,
  EMPRESA: null,
  dataCriacao: null,
  dataEncerramento: null,
  ativo: 1
}

const defaultDependencies = {
  companies: [],
  units: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Número', field: 'formatNumber(item.numero, "000")', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Cliente', field: 'item.empresa.nome', size: -1, sortable: 0, exportable: 0, wrap: 1 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'CNPJ', field: 'item.empresa.cnpj', size: -1, sortable: 0, exportable: 0, wrap: 1 },
  { name: 'Sede', field: 'item.empresa.endereco', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Bairro', field: 'item.empresa.bairro', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Município', field: 'item.empresa.municipio + " - " + item.empresa.uf', size: -1, sortable: 0, exportable: 0, wrap: 1 },
  { name: 'Criação', field: 'formatDate(item.dataCriacao)', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Encerramento', field: 'formatDate(item.dataEncerramento)', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Situação', field: '(item.ativo) ? ("Ativo") : ("Inativo")', size: -1, sortable: 0, exportable: 0, wrap: 0 }
];

const defaultEmptyMessage = "Nenhum Contrato Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Contratos pelo Número', refine: 1, label: 'Número do Contrato', history: 0 },
  { id: 2, name: 'Histórico de Contratos pelo Número', refine: 2, label: 'Número do Contrato', history: 1 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  visao: defaultVisions[0]
}

const Contracts = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);

  const [state, setState] = useState(defaultState);

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = async (item) => {
    await agm.get('/contratos/edicao/' + item.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            companies: response.data.empresas,
            units: response.data.unidades
          }
        );
        setItem(item);
        setOpenEditionDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openCreation = async (item) => {
    await agm.get('/contratos/edicao/' + item.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            companies: response.data.empresas,
            units: response.data.unidades
          }
        );
        setItem(item);
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Contrato de Manutenção',
      message: 'Deseja excluir o contrato de manutenção selecionado?',
      warn: 'Esta ação irá apagar todos os dados deste contrato de manutenção.'
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const createValues = (values) => {
    agm.post('/contratos', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const updateValues = (values) => {
    agm.put('/contratos/' + values.id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const deleteValues = (values) => {
    agm.delete('/contratos/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const refreshItems = () => {
    agm.post('/contratos/historico', { filtro: filter }, {
    }).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows) => {
    var value = {
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    agm.post('/contratos/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
    })
  }

  return (
    <Page
      className={classes.root}
      title="Contratos"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={AiOutlineFileProtect}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations item={item}
          message={message}
          open={openTreatmentDialog}
          close={closeTreatment}
          confirmation={updateTreatmentValues} />

        <Contract item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          selectedMode={selectedMode}
        />

        <Create item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultset={state}
                resultModes={resultModes}
                icon={AiOutlineFileProtect}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
              />
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};

export default Contracts;